// extracted by mini-css-extract-plugin
export default {"CartEmpty":"CartEmpty_CartEmpty__9riAx"};